import { ExportAllListActions } from '../ExportAllButton';
import React from 'react';
import {
  ListGuesser,
  ShowGuesser,
  CreateGuesser,
  FieldGuesser,
  InputGuesser,
  EditGuesser,
} from '@api-platform/admin';
import { Grid, Box, Typography, Paper } from '@mui/material';
import {
  ReferenceArrayField,
  ReferenceField,
  ReferenceInput,
  SelectArrayInput,
  SelectInput,
  SingleFieldList,
  TextField,
  ChipField,
  ReferenceArrayInput,
  DateField,
  useRecordContext,
} from 'react-admin';
import { AddressInputs } from '../Inputs/AddressInputs';
import { getSelectedCompanyFilter } from '../../helper/filter';
import { RichTextInput } from 'ra-input-rich-text';

export const CityList = (props) => {
  const companyFilter = getSelectedCompanyFilter();
  return (
    <ListGuesser actions={<ExportAllListActions />} {...props} filter={companyFilter}>
      <FieldGuesser source={'name'} />
      <ReferenceField label="Company" source="company" reference="companies">
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField label="CreatedBy" source="createdBy" reference="users">
        <TextField source="email" />
      </ReferenceField>
      <DateField source={'updatedAt'} locales={'de'} showTime />
      <DateField source={'createdAt'} locales={'de'} showTime />
    </ListGuesser>
  );
};

export const CityShow = (props) => (
  <ShowGuesser {...props}>
    <FieldGuesser source={'name'} />
    <FieldGuesser source={'drupalId'} />
    <FieldGuesser source={'oldId'} />
    <FieldGuesser source={'code'} />
    <FieldGuesser source={'msBookingsUrl'} />
    <ReferenceArrayField label="Users" reference="users" source="users">
      <SingleFieldList>
        <ChipField source="email" />
      </SingleFieldList>
    </ReferenceArrayField>
    <ReferenceField
      label="Inquiry Contact Person"
      source="inquiryContactPerson"
      reference="users"
    >
      <TextField source="email" />
    </ReferenceField>
    <ReferenceField
      label="Review Contact Person"
      source="reviewContactPerson"
      reference="users"
    >
      <TextField source="email" />
    </ReferenceField>
    <FieldGuesser source={'createdAt'} />
    <FieldGuesser source={'updatedAt'} />
    <ReferenceField label="CreatedBy" source="createdBy" reference="users">
      <TextField source="email" />
    </ReferenceField>
    <ReferenceField label="UpdatedBy" source="updatedBy" reference="users">
      <TextField source="email" />
    </ReferenceField>
  </ShowGuesser>
);

export const CityCreate = (props) => {
  const companyFilter = getSelectedCompanyFilter();
  return (
    <CreateGuesser {...props}>
      <Grid container spacing={4} sx={{ p: 2 }}>
        <Grid item xs={4}>
          <ReferenceInput
            source="company"
            reference="companies"
            label="Company"
            filterToQuery={(searchText) => ({ name: searchText })}
          >
            <SelectInput
              fullWidth
              source="company"
              optionText="name"
              disabled={true}
              defaultValue={companyFilter.company}
            />
          </ReferenceInput>
          <InputGuesser fullWidth source={'name'} />
          <InputGuesser fullWidth source={'code'} />
          <InputGuesser fullWidth source={'msBookingsUrl'} />
          <CityInquiryAndThankYouPageInputs/>

        </Grid>
        <Grid item xs={4}>
          <AddressInputs />
        </Grid>
      </Grid>
    </CreateGuesser>
  );
};

export const CityInquiryAndThankYouPageInputs = () => {
  return (
    <><Box component={Paper} sx={{ p: 2, mb: 4 }}>
      <Typography variant="h6" gutterBottom>
        Default Inquiry Page
      </Typography>

      <RichTextInput
        label="Default Inquiry Page Text"
        source="defaultInquiryPageText"
      />
      <InputGuesser fullWidth source="defaultInquiryPageImage" />
    </Box>
      <Box component={Paper} sx={{ p: 2, mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          Default Thank You Page
        </Typography>
        <RichTextInput
          label="Default Thank You Page Text"
          source="defaultThankYouPageText"
        />
        <InputGuesser fullWidth source="defaultThankYouPageImage" />
      </Box>

      <Box component={Paper} sx={{ p: 2, mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          Education Inquiry Page
        </Typography>

        <RichTextInput
          label="Education Inquiry Page Text"
          source="educationInquiryPageText"
        />
        <InputGuesser fullWidth source="educationInquiryPageImage" />
      </Box>
      <Box component={Paper} sx={{ p: 2, mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          Education Thank You Page
        </Typography>
        <RichTextInput
          label="Education Thank You Page Text"
          source="educationThankYouPageText"
        />
        <InputGuesser fullWidth source="educationThankYouPageImage" />
      </Box>

      <Box component={Paper} sx={{ p: 2, mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          Retraining Inquiry Page
        </Typography>

        <RichTextInput
          label="Retraining Inquiry Page Text"
          source="retrainingInquiryPageText"
        />
        <InputGuesser fullWidth source="retrainingInquiryPageImage" />
      </Box>
      <Box component={Paper} sx={{ p: 2, mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          Retraining Thank You Page
        </Typography>
        <RichTextInput
          label="Retraining Thank You Page Text"
          source="retrainingThankYouPageText"
        />
        <InputGuesser fullWidth source="retrainingThankYouPageImage" />
      </Box>
    </>
  )
}

export const CityEdit = (props) => (
  <EditGuesser {...props}>
    <CityEditInputs />
  </EditGuesser>
);

export const CityEditInputs = (props) => {
  const record = useRecordContext();

  if (!record) {
    return null;
  }

  console.log(record);

  return (
    <Grid container spacing={4} sx={{ p: 2 }}>
      <Grid item xs={4}>
        <InputGuesser fullWidth source={'name'} />
        <InputGuesser fullWidth source={'msBookingsUrl'} />
        <ReferenceArrayInput
          fullWidth
          source="users"
          reference="users"
          label="Users"
          filter={{
            'companies[]': record.company,
          }}
        >
          <SelectArrayInput
            fullWidth
            source="users"
            optionText="email"
            optionValue={'@id'}
          />
        </ReferenceArrayInput>
        <ReferenceInput
          fullWidth
          source="inquiryContactPerson"
          reference="users"
          filter={{
            'cities[]': record.id,
          }}
        >
          <SelectInput
            fullWidth
            source="users"
            optionText="email"
            optionValue={'@id'}
          />
        </ReferenceInput>
        <ReferenceInput
          fullWidth
          source="reviewContactPerson"
          reference="users"
          filter={{
            'cities[]': record.id,
          }}
        >
          <SelectInput
            fullWidth
            source="users"
            optionText="email"
            optionValue={'@id'}
          />
        </ReferenceInput>
        <CityInquiryAndThankYouPageInputs/>
      </Grid>
      <Grid item xs={4}>
        <AddressInputs />
      </Grid>
    </Grid>
  );
};
